import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Style
import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => {
  return {
    root: {},
  };
};

class Terminology extends Component {
  static propTypes = {
    terminology: PropTypes.object.isRequired,
    term: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
    casing: PropTypes.string.isRequired,
    withSpace: PropTypes.bool,
  };

  render() {
    const { terminology, casing, term, classes, withSpace } = this.props;

    if (casing && casing !== 'capitalize' && casing !== 'lowercase' && casing !== 'uppercase') {
      console.error('Error: Terminology does not compute casing prop.'); // eslint-disable-line
    }

    return (
      <span
        className={classes.root}
        style={{ textTransform: casing, marginLeft: withSpace ? 4 : 0 }}
      >
        {terminology[term]}
      </span>
    );
  }
}

export default withStyles(styles)(Terminology);
